import { useMemo } from 'react';
import { useGetContentTypeConditions } from './useGetContentTypeConditions';
import store from 'src/redux/store';
import { getBlogData } from '../../ListPresentation/utils';
import { useGetIterableItems } from './useGetIterableItems';

export default function useGetItemsToIterate({
  cardFrameConfig,
  props,
  listPresentationConfig,
  instaUserData
}) {
  const { contentTypeConditions } = useGetContentTypeConditions({
    listPresentationConfig,
  });
  const contentType = listPresentationConfig?.contentItems?.type;

  const { iterableList: iterableListDefault, moreItemsAvailable } = useGetIterableItems({
    builderCollections: listPresentationConfig?.contentItems?.listItem,
    contentType,
    removeNotVisibleItems: true,
    dependency: [listPresentationConfig?.contentItems, cardFrameConfig?.testimonialsList],
  });

  const iterableList = useMemo(() => {
    if (contentTypeConditions.multiColumn)
      return cardFrameConfig?.multiColumnData?.filter((item) => item?.isVisible);
    if (contentTypeConditions.logoSlider) {
      const visibleLogo = cardFrameConfig?.multiColumnData?.filter(
        (data) => data?.isVisible
      );
      return visibleLogo;
    }
    if (contentTypeConditions.blogs) {
      const blogData =
        store.getState().additionalPagesReducer?.additionalPageList?.blog?.json_data?.blog
          ?.users_list?.list || props?.blogData;
      return getBlogData(blogData);
    }
    if (contentTypeConditions.featuredReels)
      return cardFrameConfig?.reelsData?.filter((reelItem) => !!reelItem.reelUrl) || [];
    if (contentTypeConditions.testimonials)
      return (
        cardFrameConfig?.testimonialsList?.filter(
          (testimonial) => testimonial?.isVisible !== false
        ) || []
      );
    if (contentTypeConditions.gallery) {
      return (
        cardFrameConfig?.imagesData?.filter(
          (galleryData) => galleryData?.isVisible !== false
        ) || []
      );
    }
    if(contentTypeConditions.instagram) {
      return instaUserData?.media
    }
    return iterableListDefault;
  }, [iterableListDefault, contentTypeConditions, cardFrameConfig?.multiColumnData]);

  return { iterableList, contentTypeConditions, moreItemsAvailable };
}
